import React from 'react';
import { SvgIcon } from '@material-ui/core';
export const UnidadeIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path d="M6.68701 1.26164C6.30151 0.897163 5.69849 0.897163 5.31299 1.26164L0.46948 5.84098C0.169802 6.12431 0 6.51853 0 6.93094V12.5002C0 13.3286 0.671572 14.0002 1.5 14.0002H3C3.82843 14.0002 4.5 13.3286 4.5 12.5002V10.0002C4.5 9.72407 4.72386 9.50021 5 9.50021H7C7.27614 9.50021 7.5 9.72407 7.5 10.0002V12.5002C7.5 13.3286 8.17157 14.0002 9 14.0002H10.5C11.3284 14.0002 12 13.3286 12 12.5002V6.93094C12 6.51853 11.8302 6.12431 11.5305 5.84098L6.68701 1.26164Z" fill="currentColor"/>
  </SvgIcon>
);
